const RESET_PARAM = "reset";
const PREVIEW_PARAM = "preview";
const PREVIEW_HEADER = "X-Portal-Preview";

// The dashboard frames the portal with `?preview=1` (plus `?reset=1` to start
// a clean session). The server confirms that the frame belongs to the
// dashboard and stamps the shell; the mark is then held for this document
// only. sessionStorage would be shared with a later direct visit of the portal
// in the same tab, so it is deliberately not used for the mark. The flags are
// dropped from the URL again so an in-frame reload keeps progress.
let previewMode = false;

const previewConfirmedByServer = () =>
  document.getElementById("root")?.dataset.portalPreview === "1";

export const consumePreviewParams = (): void => {
  const url = new URL(window.location.href);
  const reset = url.searchParams.get(RESET_PARAM) === "1";
  const preview = url.searchParams.has(PREVIEW_PARAM);

  if (reset) window.sessionStorage.clear();
  previewMode = previewConfirmedByServer();
  if (!reset && !preview) return;

  url.searchParams.delete(RESET_PARAM);
  url.searchParams.delete(PREVIEW_PARAM);
  window.history.replaceState(window.history.state, "", url.toString());
};

export const isPortalPreview = (): boolean => previewMode;

export const portalPreviewHeaders = (): Record<string, string> =>
  isPortalPreview() ? { [PREVIEW_HEADER]: "1" } : {};
